import Tr from 'translations/Translations';
import {createSelectItem} from "../components/Select";

export default [
    createSelectItem("yes", Tr('yes')),
    createSelectItem("no", Tr('no')),
    createSelectItem("not_specified", Tr('not_specified'))
]